import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { ResourcesChangelog } from "@/features/resources/modules/changelog/changelog";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/resources/changelog/")({
  loader: () => ({ crumb: m.better_studio_nav_resources_changelog() }),
  component: ResourcesChangelogPage,
});

function ResourcesChangelogPage() {
  return (
    <PageShell
      icon={FileText}
      badge={m.better_studio_resources_card_changelog_meta()}
      title={m.better_studio_nav_resources_changelog()}
      description={m.better_studio_resources_card_changelog_description()}
      demo
    >
      <ResourcesChangelog />
    </PageShell>
  );
}
